import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'
import { getAnnualData, getAnnualCategoryBreakdown } from '../services/analyticsService'
import type { AnnualMonth, AnnualCategoryRow } from '../types'

export function useAnnualView(householdId: string | null, year: number) {
  const [months,       setMonths]       = useState<AnnualMonth[]>([])
  const [categoryRows, setCategoryRows] = useState<AnnualCategoryRow[]>([])
  const [loading,      setLoading]      = useState(false)

  const fetch = useCallback(() => {
    if (!householdId) return
    setLoading(true)
    Promise.all([
      getAnnualData(householdId, year),
      getAnnualCategoryBreakdown(householdId, year),
    ])
      .then(([ann, cats]) => {
        setMonths(ann)
        setCategoryRows(cats)
      })
      .finally(() => setLoading(false))
  }, [householdId, year])

  useEffect(() => {
    fetch()
    if (!householdId) return

    const channel = supabase
      .channel(`annual-view-${householdId}-${year}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'transactions', filter: `household_id=eq.${householdId}` },
        () => fetch(),
      )
      .subscribe()

    return () => { supabase.removeChannel(channel) }
  }, [fetch, householdId, year])

  return { months, categoryRows, loading }
}
